import React, { Fragment } from 'react';
import BatteryModel from '../../models/BatteryModel';

const FormPartial = (props) => {
  const { batteryModel, setBatteryModel } = props;
  let batteryModelObj = new BatteryModel(batteryModel);

  const validateValue = (field) => {
    batteryModelObj.validate(field);
  }

  const changeValue = (field, value) => {
    batteryModelObj[field] = value;
    validateValue(field);
    props.setBatteryModel(batteryModelObj.toStateJson());
  }

  return <Fragment>
    <div className="mb-1 col-md-6">
      <label htmlFor="name" className="form-label mb-1">Battery Model Name</label>
      <input
        value={batteryModel.name}
        onChange={(e) => changeValue('name', e.target.value)}
        type="text"
        className="form-control form-control-sm font-size-10"
        id="name"
        aria-describedby="nameHelp"
        placeholder='Enter Battery Model Name'
      />
      <div id="nameHelp" className="form-text text-danger mt-0">
        {batteryModel.errors.name}
      </div>
    </div>

    <div className="mb-1 col-md-6">
      <label htmlFor="ean_code" className="form-label mb-1">EAN Code</label>
      <input
        value={batteryModel.ean_code}
        onChange={(e) => changeValue('ean_code', e.target.value)}
        type="text"
        className="form-control form-control-sm font-size-10"
        id="ean_code"
        aria-describedby="eanCodeHelp"
        placeholder='Enter Model EAN Code'
      />
      <div id="eanCodeHelp" className="form-text text-danger mt-0">
        {batteryModel.errors.ean_code}
      </div>
    </div>
    <div className="mb-1 col-md-6">
      <label htmlFor="weight" className="form-label mb-1">Weight (in KG)</label>
      <input
        value={batteryModel.weight}
        onChange={(e) => changeValue('weight', e.target.value)}
        type="number"
        className="form-control form-control-sm font-size-10"
        placeholder='Enter Model Weight in Kilograms'
        id="weight"
      />
      <div id="eanCodeHelp" className="form-text text-danger mt-0">
        {batteryModel.errors.weight}
      </div>
    </div>

    <div className="mb-1 col-md-6">
      <label htmlFor="length" className="form-label mb-1">Length (in CM)</label>
      <input
        value={batteryModel.length}
        onChange={(e) => changeValue('length', e.target.value)}
        type="number"
        className="form-control form-control-sm font-size-10"
        placeholder='Enter Model length in centimeter'
        id="length"
      />
      <div id="eanCodeHelp" className="form-text text-danger mt-0">
        {batteryModel.errors.length}
      </div>
    </div>

    <div className="mb-1 col-md-6">
      <label htmlFor="width" className="form-label mb-1">Width (in CM)</label>
      <input
        value={batteryModel.width}
        onChange={(e) => changeValue('width', e.target.value)}
        type="number"
        className="form-control form-control-sm font-size-10"
        placeholder='Enter Model width in centimeter'
        id="width"
      />
      <div id="eanCodeHelp" className="form-text text-danger mt-0">
        {batteryModel.errors.width}
      </div>
    </div>

    <div className="mb-1 col-md-6">
      <label htmlFor="height" className="form-label mb-1">Height (in CM)</label>
      <input
        value={batteryModel.height}
        onChange={(e) => changeValue('height', e.target.value)}
        type="number"
        className="form-control form-control-sm font-size-10"
        placeholder='Enter Model height in centimeter'
        id="height"
      />
      <div id="eanCodeHelp" className="form-text text-danger mt-0">
        {batteryModel.errors.height}
      </div>
    </div>

    <div className="mb-1 col-md-6">
      <label htmlFor="capacity_ah" className="form-label mb-1">Capacity (in AH)</label>
      <input
        value={batteryModel.capacity_ah}
        onChange={(e) => changeValue('capacity_ah', e.target.value)}
        type="number" className="form-control form-control-sm font-size-10"
        placeholder='Enter Model Capacity in Amp Hour'
        id="capacity_ah"
      />
       <div id="eanCodeHelp" className="form-text text-danger mt-0">
        {batteryModel.errors.capacity_ah}
      </div>
    </div>

    <div className="mb-1 col-md-6">
      <label htmlFor="capacity_volt" className="form-label mb-1">Capacity (in Volt)</label>
      <input
        value={batteryModel.capacity_volt}
        onChange={(e) => changeValue('capacity_volt', e.target.value)}
        type="number" className="form-control form-control-sm font-size-10"
        placeholder='Enter Model Capacity in Volt'
        id="capacity_volt"
      />
      <div id="eanCodeHelp" className="form-text text-danger mt-0">
        {batteryModel.errors.capacity_volt}
      </div>
    </div>

    <div className="mb-1 col-md-6">
      <label htmlFor="committed_swap_cycles" className="form-label mb-1">Committed Swap Cycles</label>
      <input
        value={batteryModel.committed_swap_cycles}
        onChange={(e) => changeValue('committed_swap_cycles', e.target.value)}
        type="number"
        className="form-control form-control-sm font-size-10"
        placeholder='Enter Model Committed Swap Cycles'
        id="committed_swap_cycles"
      />
      <div id="eanCodeHelp"className="form-text text-danger mt-0">
        {batteryModel.errors.committed_swap_cycles}
      </div>
    </div>

    <div className="mb-1 col-md-6">
      <label htmlFor="istelematicsavailble" className="form-label mb-1">Telematics Available?</label>
      <select
        id="istelematicsavailble"
        onChange={(e) => changeValue('istelematicsavailble', e.target.value)}
        className="form-control form-control-sm font-size-10"
        value={batteryModelObj.istelematicsavailble}
      >
        <option value="true">Yes</option>
        <option value="false">No</option>
      </select>
    </div>

    <div className="mb-1 col-md-6">
      <label htmlFor="battery_type_id" className="form-label mb-1">Battery Type</label>
      <select
        id="battery_type_id"
        onChange={(e) => changeValue('battery_type_id', e.target.value)}
        className="form-control form-control-sm font-size-10"
        value={batteryModel.battery_type_id}
      >
        <option disabled value="">Select Battery Type</option>
        <option value="2">AAA</option>
        <option value="3">MM</option>
      </select>
      <div id="battery_type_id_help" className="form-text text-danger mt-0">
        {batteryModel.errors.battery_type_id}
      </div>
    </div>

    <div className="mb-1 col-md-6">
      <label htmlFor="description" className="form-label mb-1">Description</label>
      <textarea
        value={batteryModel.description}
        onChange={(e) => changeValue('description', e.target.value)}
        type="textarea"
        className="form-control form-control-sm font-size-10"
        id="description"
        placeholder='Enter Battery Model Description'
      />
      <div id="eanCodeHelp" className="form-text text-danger mt-0">
        {batteryModel.errors.description}
      </div>
    </div>
  </Fragment>
}

export default FormPartial;